import z from 'zod'
import { decimalSchema } from '../../utils/schema'

export const futureAccountSchema = z.object({
  currency: z.string(),
  total: decimalSchema,
  unrealised_pnl: decimalSchema,
  position_margin: decimalSchema,
  order_margin: decimalSchema,
  available: decimalSchema,
  point: decimalSchema,
  bonus: decimalSchema,
  cross_initial_margin: decimalSchema,
  cross_maintenance_margin: decimalSchema,
  cross_order_margin: decimalSchema,
  cross_unrealised_pnl: decimalSchema,
  cross_available: decimalSchema,
  cross_margin_balance: decimalSchema,
  cross_mmr: decimalSchema,
  cross_imr: decimalSchema,
  isolated_position_margin: decimalSchema,
})

export const marginAccountSchema = z.object({
  currency_pair: z.string(),
  base: z.object({
    currency: z.string(),
    available: decimalSchema,
    locked: decimalSchema,
    borrowed: decimalSchema,
    interest: decimalSchema,
  }),
  quote: z.object({
    currency: z.string(),
    available: decimalSchema,
    locked: decimalSchema,
    borrowed: decimalSchema,
    interest: decimalSchema,
  }),
})

export const spotAccountSchema = z.object({
  currency: z.string(),
  available: decimalSchema,
  locked: decimalSchema,
  update_id: z.number(),
})
